import { pinia } from '@/main'
import { useStatesStore } from '@/stores/states-store'
import { useUserStore } from '@/stores/user-store'
import { primaryColor } from '@/puls-color-theme'
import { Settings } from 'luxon'

/**
 * The behaves the same as the lodash version https://www.npmjs.com/package/lodash.get
 *
 * Source: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
 */
export const get = (obj, path, defaultValue = undefined) => {
  const travel = (regexp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj
      )
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
  return result === undefined || result === obj ? defaultValue : result
}

const interpolateVariables = ({ string, params }) => {
  let orgName = params.userInfo.organizationFullName
  if (orgName.endsWith('s') && string.includes(`{organizationName}s`)) {
    orgName = orgName.slice(0, -1)
  }
  return string
    .replace(/\{(custom:\S+)}/g, 'X')
    .replace(/{organizationName}/g, orgName)
    .replace(/{groupName}/g, params.firstGroupName)
    .replace(/{username}/g, params.userInfo.username)
    .replace(/{username}/g, params.userInfo.username)
    .replace(/{givenName}/g, params.userInfo.givenName)
}

const tr = (
  messages,
  key,
  interpolate = null,
  localeFromi18n
  // params = { userInfo: { organizationFullName: 'chtest' } }
) => {
  const userStore = useUserStore(pinia)
  if (!messages || !messages.en) {
    return '-'
  }
  let locale = localeFromi18n
  if (!messages[locale]) {
    locale = 'en' // fallback
  }
  let string = get(messages[locale], key) || null
  if (typeof string === 'object') {
    return string
  } else if (typeof string !== 'string') {
    return null
  }
  if (interpolate) {
    const regex = new RegExp(`{${interpolate.key}}`, 'g')
    string = string.replace(regex, interpolate.value)
  }
  const params = {
    userInfo: userStore.getUserInfo
    // attributes: store.getters.loggedInUser.signInUserSession.idToken.payload
  }

  return interpolateVariables({ string, params })
}

export const resultColors = {
  green: 'var(--kt-results-green)',
  yellow: 'var(--kt-results-yellow)',
  red: 'var(--kt-results-red)',
  brand: primaryColor
}

const currentAverage = (averages) => {
  const statesStore = useStatesStore(pinia)
  return averages.find((average) => {
    return average.surveyName === statesStore.surveyName
  })
}

// Define localeNumber as a standalone helper that takes in a locale
export const localeNumber = (
  number,
  fractionalDigits = 1,
  type = null,
  locale
) => {
  if (
    (typeof number === 'undefined' || isNaN(number) || number === null) &&
    type === 'tag'
  ) {
    return 'noData'
  } else if (
    typeof number === 'undefined' ||
    isNaN(number) ||
    number === null
  ) {
    return '-'
  } else if (typeof number === 'number') {
    return number.toLocaleString(locale, {
      minimumFractionDigits: fractionalDigits,
      maximumFractionDigits: fractionalDigits
    })
  } else {
    return (Number(number) || 0).toLocaleString(locale, {
      minimumFractionDigits: fractionalDigits,
      maximumFractionDigits: fractionalDigits
    })
  }
}

// TODO
export default {
  //   colorsForCurrentAverage,
  //   interpolateVariables,

  install(app, i18n, options) {
    const locale = i18n.global.locale.value
    Settings.defaultLocale = locale
    app.config.globalProperties.$get = get
    app.config.globalProperties.$tr = (messages, key, interpolate = null) =>
      tr(messages, key, interpolate, locale)
    app.config.globalProperties.$resultColors = resultColors
    app.config.globalProperties.$currentAverage = currentAverage
    app.config.globalProperties.$localeNumber = (
      number,
      fractionalDigits,
      type
    ) => localeNumber(number, fractionalDigits, type, locale)
  }
}
